import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import commonFunction from "../composables/commonFunction";
const { checkEmpty } = commonFunction();

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    exact: true,
    component: () => import("@/pages/Login.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/components/Dashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/myprofile",
    name: "profilePage",
    component: () => import("@/pages/MyProfile.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/add",
    name: "addVoter",
    component: () => import("@/pages/voters/AddVoterTabs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/voterslist",
    name: "votersList",
    component: () => import("@/pages/voters/votersList/VoterHeader.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/incompletevoters",
    name: "incompleteVoters",
    component: () => import("@/pages/voters/votersList/ListVoters.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/unassignedvoters",
    name: "unassignedVoters",
    component: () => import("@/pages/voters/votersList/ListVoters.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/mismatchedVoters",
    name: "mismatchedVoters",
    component: () => import("@/pages/voters/votersList/MismatchedVoters.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/import",
    name: "importVoters",
    component: () => import("@/pages/voters/ImportVoters.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/todayfollowup",
    name: "todayfollowup",
    component: () => import("@/pages/voters/votersList/Followup/FollowUpHeader.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/voters/pendingfollowup",
    name: "pendingfollowup",
    component: () => import("@/pages/voters/votersList/Followup/FollowUpHeader.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  
  {
    path: "/voters/search",
    name: "searchVoters",
    component: () => import("@/pages/voters/SearchVoters.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/add",
    name: "add",
    component: () => import("@/pages/users/addUser/AddUser.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/listing",
    name: "listing",
    component: () => import("@/pages/users/listUsers/ListUser.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/permissionsets",
    name: "permissionsets",
    component: () => import("@/pages/users/permissionSets/PermissionSets.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/campaigntemplate",
    name: "campaigntemplate",
    component: () =>
      import("@/pages/campaign/campaignTemplate/CampaignTemplate.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaignListing",
    name: "campaignlisting",
    component: () =>
      import("@/pages/campaign/campaignListing/CampaignListing.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/whatsapplogs/:campaignId?",
    name: "VoterWhatsAppCampaignLogs",
    component: () =>
      import(
        "@/pages/campaign/campaignListing/viewLogs/WhatsAppCampaignLogs.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/sms",
    name: "smslogs",
    component: () => import("@/pages/systemLogs/SMSlogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/smslogs/:campaignId?",
    name: "VoterSmsCampaignLogs",
    component: () =>
      import("@/pages/campaign/campaignListing/viewLogs/SmsCampaignLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/calllogs/:campaignId?",
    name: "VoterCallCampaignLogs",
    component: () =>
      import("@/pages/campaign/campaignListing/viewLogs/CallCampaignLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/pushlogs/:campaignId?",
    name: "VoterPushCampaignLogs",
    component: () =>
      import("@/pages/campaign/campaignListing/viewLogs/PushCampaignLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/logs/:campaignId?",
    name: "VoterCampaignLogs",
    component: () =>
      import("@/pages/campaign/campaignListing/viewLogs/CampaignLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/report/:campaignId?",
    name: "VoterCallCampaignReports",
    component: () =>
      import(
        "@/pages/campaign/campaignListing/reportLogs/CallCampaignReports.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaign/pushreport/:campaignId?",
    name: "PushCampaignReports",
    component: () =>
      import(
        "@/pages/campaign/campaignListing/reportLogs/PushCampaignReports.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/designation",
    name: "ClientDesignation",
    component: () => import("@/pages/settings/Designation.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/tags",
    name: "settingsTags",
    component: () => import("@/pages/settings/Tags.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/eventsettings",
    name: "EventSmsDesignation",
    component: () => import("@/pages/settings/SmsEventSettingsList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/ticketsettings",
    name: "TicketSettings",
    component: () => import("@/pages/support/TicketSettings.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/underprogress",
    name: "underprogress",
    exact: true,
    component: () => import("@/pages/settings/UnderProgress.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/webbotlogs",
    name: "WebBotlogs",
    component: () => import("@/pages/systemLogs/WebBotLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/myincoming",
    name: "IncomingLogs",
    component: () => import("@/pages/systemLogs/IncomingLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/myoutgoing",
    name: "OutgoingLogs",
    component: () => import("@/pages/systemLogs/OutgoingLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/email",
    name: "EmailLogs",
    component: () => import("@/pages/systemLogs/EmailLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/logs/aadhaar-v1-card",
    name: "AadhaarV1CardLogs",
    component: () => import("@/pages/systemLogs/AadhaarLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/voter/_search",
    name: "VoterCardLogs",
    component: () => import("@/pages/systemLogs/VotercardLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/pan-card",
    name: "PanCardLogs",
    component: () => import("@/pages/systemLogs/PANcardLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/driving-licence",
    name: "DrivingLicenceLogs",
    component: () => import("@/pages/systemLogs/DrivingLicenceLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/passport",
    name: "PassportLogs",
    component: () => import("@/pages/systemLogs/PassportLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logs/importvoter",
    name: "ImportVoterLogs",
    component: () => import("@/pages/systemLogs/ImportVoterLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/support/user",
    name: "userSupport",
    component: () => import("@/pages/support/unused/userSupportTicketTabs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/support/app",
    name: "appSupport",
    component: () => import("@/pages/support/unused/appSupportTicketTabs.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/appsupport/new",
    name: "newTicketSupport",
    component: () => import("@/pages/support/NewTicket.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/appsupport/open",
    name: "openTicketSupport",
    component: () => import("@/pages/support/OpenTicket.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/appsupport/closed",
    name: "closedTicketSupport",
    component: () => import("@/pages/support/ClosedTicket.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/appsupport/settings",
    name: "appSettingSupport",
    component: () => import("@/pages/support/TicketSettings.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cloudtelephony/virtualnumbers",
    name: "virtualnumbers",
    exact: true,
    component: () => import("@/pages/cloudtelephony/VirtualNumbers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cloudtelephony/virtualnumbers/set/:param1/:param2",
    name: "VirtualNumberSet",
    component: () => import("@/pages/cloudtelephony/VirtualNumberSetting.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/jantadarbar/virtualnumbers/set/:param1/:param2",
    name: "JantaDarbarVirtualNumberSet",
    component: () => import("@/pages/jantaDarbar/missedCall/darbarSetting.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cloudtelephony/virtualnumbers/existset/:param1/:param2",
    name: "VirtualNumberExistSet",
    component: () => import("@/pages/cloudtelephony/VirtualNumberExistSet.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cloudtelephony/customtunes",
    name: "CustomTunes",
    component: () => import("@/pages/cloudtelephony/CustomTunes.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/dashboard",
    name: "Billing Dashboard",
    component: () => import("@/pages/billing/BillingDashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/billing/invoice",
    name: "Tax Invoices",
    component: () => import("@/pages/billing/TaxInvoice.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/statement",
    name: "Account Statement",
    component: () => import("@/pages/billing/AccountStatement.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/receipt",
    name: "Payment Receipt",
    component: () => import("@/pages/billing/PaymentReceipts.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/companydetails",
    name: "Company Details",
    component: () => import("@/pages/billing/CompanyDetails.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/jantadarbar",
    name: "Janta Darbar",
    component: () => import("@/pages/jantaDarbar/JantaDarbar.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/jantadarbarparticipant/:eventId?",
    name: "VoterParticipantLogs",
    component: () => import("@/pages/jantaDarbar/ParticipantLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/birthdays",
    name: "BirthDateList",
    component: () => import("@/pages/birthdays/BirthDateList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/approvals/myrequest",
    name: "MyRequest",
    component: () => import("@/pages/requestapprovals/MyRequest.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/approvals/teamsrequest",
    name: "TeamsRequest",
    component: () => import("@/pages/requestapprovals/TeamsRequest.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/approvals/approverequest",
    name: "RequestsToApproveTag",
    component: () =>
      import("@/pages/requestapprovals/RequestsToApproveTag.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/generateaudio",
    name: "GenerateAudio",
    component: () => import("@/pages/generateAudio/Voice.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/appusers",
    name: "AppUsersUsage",
    component: () => import("@/pages/appUsers/AppUserList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/karyakartas/list",
    name: "KaryakartasList",
    component: () =>
      import("@/pages/karyakartas/listKaryakartas/ListKaryakartas.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/karyakartas/add",
    name: "Newkaryakartas",
    component: () =>
      import("@/pages/karyakartas/addKaryakartas/AddKaryakartas.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/underprogress",
    name: "underprogress page",
    exact: true,
    component: () => import("@/pages/settings/UnderProgress.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/jobopportunities",
    name: "Job page",
    exact: true,
    component: () => import("@/pages/jobs/JobOpportunities.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bloodbank",
    name: "online blood bank",
    exact: true,
    component: () => import("@/pages/bloodbank/BloodBankList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bloodbank/logs",
    name: "BloodBankLogs",
    exact: true,
    component: () => import("@/pages/bloodbank/BloodCallLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/plasma",
    name: "online Plasma",
    exact: true,
    component: () => import("@/pages/plasma/PlasmaList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/plasma/logs",
    name: "PlasmaLogs",
    exact: true,
    component: () => import("@/pages/plasma/PlasmaLogs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schemes",
    name: "govt schemes",
    exact: true,
    component: () => import("@/pages/schemes/GovernmentSchemes.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/app-popup",
    name: "AppPopup",
    exact: true,
    component: () => import("@/pages/appPopup/AppPopup.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("../components/Maintenance.vue"),
    meta: { allowDuringMaintenance: true }
  },
  {
    path: "/email/emailVerify",
    name: "EmailVerify",
    exact: true,
    component: () => import("@/pages/EmailVerify.vue"),
    meta: {
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async (to, from, next) => {
  await store.dispatch("checkLoginCredentials");
  const authenticatedUser = store.state.loggedInUserSessions.user_reference;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const checkModuleAccess = to.matched.some(
    (record) => record.meta.checkModuleAccess
  );
  const moduleId = to.meta.moduleId;
  const permission_fks = [1, 11, 12];
  const maintenanceMode = checkEmpty(store.state.systemStatus.mcd4) && store.state.systemStatus.mcd4 == 1;
  if (maintenanceMode && !to.matched.some((record) => record.meta.allowDuringMaintenance)) {
    return next({ path: "/maintenance" });
  } else if (to.matched.some((record) => record.meta.allowDuringMaintenance) && !maintenanceMode) {
    return next({ path: "/login" });
  }

  if (requiresAuth && !authenticatedUser) {
    next("/login");
  } else {
    if (checkModuleAccess) {
      if (permission_fks.includes(moduleId)) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
});

export default router;
